module.exports = __webpack_public_path__ + "static/userFeedback-94cad1e020bfca3ae03f9235592458f7.jpg";